import { render, staticRenderFns } from "./PreferencesIcon.vue?vue&type=template&id=1d9b82f6&"
import script from "./PreferencesIcon.vue?vue&type=script&lang=ts&"
export * from "./PreferencesIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports